import React, { useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import Message from "@/components/message";
import arrow from "@/assets/images/common/arrow.png";
import Api from "@/service";
import { useUserInfoStore, useAuthStore } from "@/stores";

import "./index.scss";

type BatchImages = Record<string, string>;

interface SharePanelProps {
  onGetCode: () => void;
  batchImages: BatchImages;
  variant?: "pc" | "mobile";
  className?: string;
}

const SharePanel: React.FC<SharePanelProps> = ({
  batchImages,
  variant = "pc",
  className,
  onGetCode,
}) => {
  const { t } = useTranslation();
  const [shareCode, setShareCode] = useState<string>("");
  const { refreshUserInfo } = useUserInfoStore();
  const { isLoggedIn } = useAuthStore();

  const submitShareCode = async () => {
    if (shareCode.trim() === "") {
      Message.error({ content: t("inputCode") });
      return;
    }
    // 验证是否登录
    if (!isLoggedIn) {
      Message.error({ content: t("login") });
      return;
    }

    const res = await Api.submitShareCode(shareCode);

    if (res.code === 0) {
      Message.success({ content: t("codeSuccess") });
      refreshUserInfo();
    }
  };

  return (
    <div className={classnames("share", className)}>
      {variant === "pc" && <img src={batchImages["pc_p2_share_png"]} />}

      <div className='getCode' onClick={onGetCode}>
        <img src={batchImages["pc_p2_getCode_png"]} />
      </div>
      <div className='inputValue'>
        <input
          type='text'
          placeholder={t("inputCode")}
          onChange={(e) => setShareCode(e.target.value)}
          value={shareCode}
        />
        <img
          src={arrow}
          alt=''
          style={{ cursor: "pointer" }}
          onClick={submitShareCode}
        />
      </div>
    </div>
  );
};

export default SharePanel;
